<template>
  <div class="vertical-center text-center">
    <p id="svg-sad">
      <SadSvg />
    </p>
    <p>{{ message }} <strong>(404)</strong></p>
    <b-button
      variant="outline-primary"
      @click="$router.push({ name: 'overview' })"
      >{{ buttonText }}
    </b-button>
  </div>
</template>

<script>
import SadSvg from "./../../assets/images/sad.svg";

export default {
  name: "pages-404",
  components: {
    SadSvg
  },
  data() {
    return {
      message: "Sorry, nothing here...",
      buttonText: "Go Back"
    };
  }
};
</script>

<style scoped>
.vertical-center {
  margin-top: 25%;
}

#svg-sad svg {
  margin-bottom: 30px;
}
</style>
